import { render, staticRenderFns } from "./HcButton.vue?vue&type=template&id=645b793a&scoped=true&"
import script from "./HcButton.vue?vue&type=script&lang=js&"
export * from "./HcButton.vue?vue&type=script&lang=js&"
import style0 from "./HcButton.vue?vue&type=style&index=0&id=645b793a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.0_enyi6aqizbgycdmugvkasw26ru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645b793a",
  null
  
)

export default component.exports